const config = {
  environment: process.env.REACT_APP_ENV,
  title: process.env.REACT_APP_ENV === 'production' ? 'HP Siteprint' : '[DEV] HP Siteprint',
  apiURL: process.env.REACT_APP_API_URL,
  mediaURL: process.env.REACT_APP_MEDIA_URL,
  mediaName: process.env.REACT_APP_MEDIA_NAME,
  menu: [
    {
      type: 'Post',
      title: 'Posts',
      items: [
        {
          type: 'Post',
          title: 'Posts',
        },
        {
          type: 'PostTag',
          title: 'Tags',
        },
        {
          type: 'PostCategory',
          title: 'Categories',
        },
        {
          type: 'PostSegment',
          title: 'Segments',
        },
        {
          type: 'PostSubsegment',
          title: 'Subsegments',
        },
      ]
    },
    {
      type: 'Common',
      title: 'Common',
      items: [
        {
          type: 'Common',
          title: 'Commons',
        },
        {
          type: 'Header',
          title: 'Headers',
        },
        {
          type: 'MenuLink',
          title: 'Menu Links',
        },
      ]
    },
    {
      type: 'Video',
      title: 'Videos',
      items: [
        {
          type: 'Video',
          title: 'Videos',
        },
        {
          type: 'VideoCategory',
          title: 'Video categories',
        },
      ]
    },
    {
      type: 'CustomFile',
      title: 'Files',
      items: [
        {
          type: 'CustomFile',
          title: 'Files',
        },
      ]
    },
    {
      type: 'Literal',
      title: 'Config',
      items: [
        {
          type: 'Literal',
          title: 'Literals',
        },
        {
          type: 'Country',
          title: 'Countries',
        },
        {
          type: 'Language',
          title: 'Languages',
        },
        {
          type: 'User',
          title: 'Users',
        },
      ]
    },
  ],
}

export default config
